import UmlShape from './UmlShape';

// EA-style "stereotyped box with an icon" shape (database, external system, web
// app/service, server, etc.) — a stereotype in the strict UML sense is just a
// tagged rectangle, but tools like Enterprise Architect swap the rectangle for
// a small custom icon per stereotype. Rather than bolt that onto UmlClassShape
// (which already carries members/collapse/inherits — unrelated concerns for a
// pure icon box, see session discussion 2026-07-12), this is its own minimal
// shape type: just a caption (text + optional stereotype, reusing UmlCaption
// exactly like UmlClassShape does) + an iconKind + an optional description.
// v1 iconKind is one of a small hardcoded set (see UmlIconShapeIcons.js) or
// 'none' (caption/stereotype box only, no icon drawn). A later version may add
// a free-text SVG field (stored inline in the note body, no upload needed) —
// out of scope for now.
class UmlIconShape extends UmlShape {
  constructor(id, x, y, w, h, caption, iconKind, description) {
    super(id, x, y, w, h);
    this.caption = caption; // UmlCaption
    this.iconKind = iconKind || 'externalSystem'; // key into UMLICONSHAPE_ICONS, or 'none'
    this.description = description || null; // vrije tekst, zelfde JxHint-tooltip patroon als UmlClassShape
    this.kind = 'icon'; // discriminant voor UmlShapeSerializer.fromPlainShape (JSON heeft geen class-info)
  }

  setIconKind(iconKind) {
    this.iconKind = iconKind;
  }

  setDescription(description) {
    this.description = description;
  }
}

export default UmlIconShape;
